import { LANGUAGES } from '../constants';
import type { LanguageCode } from '../types';

export const checkLanguageExists = (
  language: string
): language is LanguageCode =>
  Object.keys(LANGUAGES).some((appLanguage) => appLanguage === language);
